import React from 'react';
import OwlCarousel from 'react-owl-carousel'; // Import OwlCarousel
import 'owl.carousel/dist/assets/owl.carousel.css'; // Import Owl Carousel styles
import 'owl.carousel/dist/assets/owl.theme.default.css';
import knackhook from '../assets/images/kh.jpg';
import signin from '../assets/images/signin.jpg'
import signinsoft from '../assets/images/signinsoft.png';

// Partner logos data
const partners = [
  knackhook,
  signin, 
  knackhook,
  signin,
];

const Partners = () => {
  return (
    <div id="Partners">
      <section className="clients-section sec-padd mb-5">
        <div className="container">
          <div className="section-title">
            <h2>Our Partners</h2>
          </div>

          <OwlCarousel
            className="owl-theme" style={{marginTop:'100px'}}
            loop
            margin={50}
            autoplay
            autoplayTimeout={3000}
            nav={true}
            dots={false}
            responsive={{
              0: { items: 2 },
              600: { items: 3 },
              1000: { items: 4 },
            }}
          >
            {partners.map((logo, index) => (
              <div className="item tool_tip" key={index} data-original-title="Media Partner"style={{border:'1px solid #c9c9c9',padding:'30px',borderRadius:'25px 0 25px 0'}}>
                <img src={logo} alt="Partner Logo" className='img-fluid' />
              </div>
            ))}
          </OwlCarousel>
        </div>
      </section>
    </div>
  );
};

export default Partners;
